(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sizeguide"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('size-guide')) return;

    var lockCount = 0;
    var saved = { overflow: '', paddingRight: '' };

    function lockScroll() {
      if (lockCount === 0) {
        var html = document.documentElement;
        var sbw = window.innerWidth - html.clientWidth;
        saved.overflow = html.style.overflow;
        saved.paddingRight = html.style.paddingRight;
        html.style.overflow = 'hidden';
        if (sbw > 0) html.style.paddingRight = sbw + 'px';
      }
      lockCount++;
    }

    function unlockScroll() {
      if (lockCount === 0) return;
      lockCount--;
      if (lockCount === 0) {
        var html = document.documentElement;
        html.style.overflow = saved.overflow;
        html.style.paddingRight = saved.paddingRight;
      }
    }

    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    class SizeGuide extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.dialog = this.querySelector('.sg-dialog');
        this.panel = this.querySelector('.sg-panel');
        this.trigger = this.querySelector('.sg-trigger');
        this.scroller = this.querySelector('.sg-scroll');
        this.duration = parseInt(this.dataset.duration || '260', 10) || 0;
        this._locked = false;
        this._closing = false;
        this._downOutside = false;

        if (!this.dialog || !this.panel || !this.trigger) return;

        this.trigger.addEventListener('click', () => this.open());

        this.querySelectorAll('[data-sg-close]').forEach((btn) => {
          btn.addEventListener('click', () => this.close());
        });

        /* Clic hors de la fenêtre : il faut que l'appui ET le relâchement soient dehors
           (évite de fermer quand on sélectionne du texte et qu'on relâche à l'extérieur). */
        this.dialog.addEventListener('pointerdown', (e) => {
          this._downOutside = !this.panel.contains(e.target);
        });
        this.dialog.addEventListener('click', (e) => {
          if (this._downOutside && !this.panel.contains(e.target)) this.close();
          this._downOutside = false;
        });

        /* Échap */
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
        this.dialog.addEventListener('close', () => this._release());

        /* Onglets */
        this.tabs = Array.prototype.slice.call(this.querySelectorAll('.sg-tab'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.selectTab(i, false));
          tab.addEventListener('keydown', (e) => {
            var n = this.tabs.length;
            var next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % n;
            else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = n - 1;
            if (next !== null) {
              e.preventDefault();
              this.selectTab(next, true);
            }
          });
        });

        /* Lignes : un appui surligne, un second appui retire */
        this.querySelectorAll('.sg-row').forEach((row) => {
          row.addEventListener('click', () => {
            var table = row.closest('.sg-table');
            var turnOn = row.getAttribute('aria-pressed') !== 'true';
            table.querySelectorAll('.sg-row').forEach((r) => r.setAttribute('aria-pressed', 'false'));
            row.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
          });
        });

        /* Éditeur de thème : ouvre la fenêtre quand le bloc est sélectionné */
        if (window.Shopify && window.Shopify.designMode && this.dataset.editorPreview === 'true') {
          this._onSelect = (e) => {
            if (e.detail && e.detail.blockId === this.dataset.blockId) this.open();
          };
          this._onDeselect = (e) => {
            if (e.detail && e.detail.blockId === this.dataset.blockId) this.close(true);
          };
          document.addEventListener('shopify:block:select', this._onSelect);
          document.addEventListener('shopify:block:deselect', this._onDeselect);
        }
      }

      disconnectedCallback() {
        if (this._onSelect) document.removeEventListener('shopify:block:select', this._onSelect);
        if (this._onDeselect) document.removeEventListener('shopify:block:deselect', this._onDeselect);
        clearTimeout(this._timer);
        this._release();
      }

      selectTab(index, focus) {
        this.tabs.forEach((tab, i) => {
          var on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.setAttribute('tabindex', on ? '0' : '-1');
          var panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        var t = this.tabs[index];
        if (t) {
          if (focus) t.focus();
          if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      open() {
        /* Réouverture pendant l'animation de fermeture */
        if (this._closing) {
          clearTimeout(this._timer);
          this._closing = false;
          this.dialog.classList.add('is-open');
          return;
        }
        if (this.dialog.open) return;

        if (!this._locked) {
          lockScroll();
          this._locked = true;
        }
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        if (this.scroller) this.scroller.scrollTop = 0;
        this.panel.focus({ preventScroll: true });

        /* Double rAF : l'état initial est peint avant la transition */
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.dialog.classList.add('is-open'));
        });
      }

      close(instant) {
        if (!this.dialog.open || this._closing) return;
        this._closing = true;
        this.dialog.classList.remove('is-open');
        var delay = instant || reducedMotion() ? 0 : this.duration;
        clearTimeout(this._timer);
        this._timer = setTimeout(() => {
          this._closing = false;
          if (typeof this.dialog.close === 'function') {
            this.dialog.close();
          } else {
            this.dialog.removeAttribute('open');
          }
          this._release();
        }, delay);
      }

      _release() {
        if (this._locked) {
          unlockScroll();
          this._locked = false;
        }
      }
    }

    customElements.define('size-guide', SizeGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
